import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Row,
  Col,
  Container,
  Button,
  Table,
  Card,
  Modal,
  Form,
} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import api from "../../services/api";
import { format, subHours } from 'date-fns';
import { ptBR } from "date-fns/locale";
import { toast } from "react-toastify";
import loader from "../../assets/images/page-img/page-load-loader.gif";
import AnimationWarningLottie from "../../components/AnimationWarningDeleteConfim/AnimationWarningLottie";
import { FaSearch } from "react-icons/fa";

const Notification = () => {
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const token = Cookies.get("token");
  const [modalShow, setModalShow] = useState(false);
  const [notificationIdToDelete, setNotificationIdToDelete] = useState("");
  const observer = useRef();
 
const formatAsBrasiliaTime = (utcDateString) => {
  const dateInUtc = new Date(utcDateString);
  const dateInBRT = subHours(dateInUtc, 3); // -3h de UTC → Brasília
  return format(dateInBRT, 'dd/MM/yyyy HH:mm', { locale: ptBR });
};

  const navigate = useNavigate();
  const [searchInput, setSearchInput] = useState("");
  const [searchDebounced, setSearchDebounced] = useState("");

  const fetchNotifications = async (pageNumber = 1) => {
    if (isLoading) return;

    setIsLoading(true);
    try {
      const response = await api.get(`/api/notifications`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          page: pageNumber,
          search: searchInput,
        },
      });

      const newNotifications = response.data.data;

      setNotifications((prev) => {
        const ids = new Set(prev.map((n) => n.id));
        const filtered = newNotifications.filter((n) => !ids.has(n.id));
        return [...prev, ...filtered];
      });

      setHasMore(response.data.next_page_url !== null);
    } catch (error) {
      console.error("Erro ao buscar notificações:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      setSearchDebounced(searchInput); // apenas atualiza a busca com delay
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchInput]);

  const lastNotificationRef = useCallback(
    (node) => {
      if (isLoading || !hasMore) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  useEffect(() => {
    const fetch = async () => {
      if (page === 1) setNotifications([]); // limpa só na página 1
      await fetchNotifications(page);
    };
    fetch();
  }, [page, searchDebounced]);

  useEffect(() => {
    setPage(1);
    setHasMore(true);
  }, [searchDebounced]);

  const showCreateNotification = () => {
    navigate(`/notifications/create`);
  };

  const showDeleteNotificationConfirmationModal = (id) => {
    setModalShow(true);
    setNotificationIdToDelete(id);
  };

  const deleteNotification = async (id) => {
    try {
      await api.delete(`/api/notifications/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setNotifications((prev) => prev.filter((n) => n.id !== id));
      setModalShow(false);
      toast.success("Notificação deletada com sucesso!", { autoClose: 3000 });
    } catch {
      toast.error("Erro ao deletar notificação", { autoClose: 3000 });
    }
  };

  function DeleteNotificationConfirmationModal(props) {
    return (
      <Modal {...props} centered>
        <Modal.Header closeButton>
          <Modal.Title>Excluir Notificação</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <AnimationWarningLottie />
            <p>Deseja realmente excluir esta notificação?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => deleteNotification(props.notificationid)}>
            Sim
          </Button>
          <Button onClick={props.onHide}>Não</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  return (
    <div id="content-page" className="content-inner">
      <Container>
        <DeleteNotificationConfirmationModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          notificationid={notificationIdToDelete}
        />
        <Row>
          <Col sm="12">
            <Card className="position-relative inner-page-bg bg-primary p-5">
              <div
                className="inner-page-title"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "-webkit-fill-available",
                }}
              >
                <h3 className="text-white">Notificações Personalizadas</h3>
                <Link
                  to="/notifications/notification"
                  className="text-white py-1 px-2"
                >
                  <i className="icon material-symbols-outlined d-flex">
                    arrow_back
                  </i>
                </Link>
              </div>
            </Card>
          </Col>

          <Col sm="12" lg="12">
            <Card>
              <Card.Body className="pt-0">
                <div className="mb-4 mt-4">
                  <Form.Group className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      <FaSearch />
                    </span>
                    <Form.Control
                      placeholder="Pesquisar"
                      aria-label="pesquisar"
                      aria-describedby="search"
                      value={searchInput}
                      onChange={(e) => setSearchInput(e.target.value)}
                    />
                    <Button
                      onClick={(e) => showCreateNotification(e)}
                      id="buttonNew"
                      className="borderbtnCreateEdit"
                    >
                      <i className="icon material-symbols-outlined d-flex">
                        add
                      </i>
                    </Button>
                  </Form.Group>
                </div>

                <table className="table table-responsive">
                  <thead>
                    <tr>
                      <th>Título</th>
                      <th>Mensagem</th>
                      <th>Imagem</th>
                      <th>URL</th>
                      <th>Agendada</th>
                      <th>Criada em</th>
                      <th>Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    {notifications.map((n, index) => (
                      <tr
                        key={n.id}
                        ref={
                          notifications.length === index + 1
                            ? lastNotificationRef
                            : null
                        }
                      >
                        <td>{n.title}</td>
                        <td>{n.body}</td>
                        <td>
                          {n.image_url && (
                            <img
                              src={n.image_url}
                              alt="img"
                              width={50}
                              height={50}
                              style={{ objectFit: "cover" }}
                            />
                          )}
                        </td>
                        <td>{n.url}</td>
                        <td>

                          {n.scheduled_at
                            ? formatAsBrasiliaTime(n.scheduled_at)
                            : "-"}
                        </td>
                        <td>
                          {format(new Date(n.created_at), "dd/MM/yyyy HH:mm", {
                            locale: ptBR,
                          })}
                        </td>
                        <td>
                          <Button
                            onClick={() =>
                              showDeleteNotificationConfirmationModal(n.id)
                            }
                          >
                            <i className="material-symbols-outlined">delete</i>
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {isLoading && (
                  <div className="text-center mt-2">
                    <img src={loader} alt="Carregando..." height={50} />
                  </div>
                )}
                {!hasMore && !isLoading && (
                  <div className="text-center mt-2 mb-2 text-muted">
                    <small>Por enquanto isso é tudo.</small>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Notification;
